import { Component, Input } from '@angular/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-tile-link',
    templateUrl: './tile-link.component.html',
    imports: [NgClass, NgTemplateOutlet, RouterLink]
})
export class TileLinkComponent extends GenericLinkComponent {
  @Input() url: string;
  @Input() target: string;
  @Input() classes: string[];
  @Input() overridenLocalUrl: string;
}
